import {type BskyAgent} from '@atproto/api'

import {wsocFetch, xrpcPath} from '#/lib/wsoc/fetch'
import {type AllocateWidResponse} from './types'

/**
 * Allocate a WID inventory entry for the current user's account.
 * Idempotent — returns the same entry if the user already has one within TTL.
 *
 * @throws WsocFetchError with code "InventoryEmpty" or "AlreadyLinked" on failure
 */
export async function allocateWidForAccount(
  agent: BskyAgent,
  options?: {signal?: AbortSignal},
): Promise<AllocateWidResponse> {
  const accessJwt = agent.session?.accessJwt
  if (!accessJwt) {
    throw new Error('allocateWidForAccount requires an authenticated session')
  }
  return wsocFetch<AllocateWidResponse>(
    xrpcPath('eu.wsocial.server.allocateWidForAccount'),
    {accessJwt, signal: options?.signal},
  )
}
